// extracted by mini-css-extract-plugin
export var header = "header-module--header---h9hJ";
export var headerHide = "header-module--header-hide--pPkKW";
export var headerTitle = "header-module--header-title--1OdPb";